import {TOKENS} from '../../tokens'

/**
 * Semantic tokens used by the onboarding surfaces
 * (`src/screens/SignUpWizard/*`, `src/screens/WIDUpgrade/*`).
 *
 * Onboarding is dark-forced today, so `light` mirrors `dark`. Values map
 * one-to-one to the CSS variables observed in the Figma W Design System
 * (node 4609-16144). Literals appear inline where a matching token in
 * `TOKENS.dark` does not yet exist; document the Figma variable in a
 * trailing comment.
 */
const dark = {
  bg: TOKENS.dark.custom_background_primary, // Figma bg/default #161928
  textPrimary: TOKENS.dark.contrast_1000, // Figma text/default #FFFFFF
  textMedium: '#D0CFD7', // Figma text/contrast-medium
  textLow: '#7E7B8E', // Figma text/contrast-low
  btnPrimaryBg: TOKENS.dark.positive_700, // Figma btn-primary/fill #11E8B2
  btnPrimaryText: TOKENS.dark.custom_text_light, // Figma btn-primary/text #2C0078
  btnSecondaryBg: '#272F44', // Figma btn-secondary/fill
  btnSecondaryText: '#D0CFD7', // Figma btn-secondary/text
  borderLow: TOKENS.dark.custom_border_contrast_low, // Figma border/contrast-low
  illustrationBg: '#2B2932', // Figma w-dark/contrast/100
  negative: TOKENS.dark.negative_500,
  inputBg: '#272F44',
  checkboxBg: '#1E2434',
  textPlaceholder: '#9997A7',
} as const

export const onboarding = {
  dark,
  light: dark,
} as const
